import { manageOrganizationContext } from "./ManageOrganizationContext";

export const ManageOrganizationProvider = manageOrganizationContext.Provider